import { useEffect } from 'react';

import { Zone } from 'types';

import { FormItem } from 'sections/EditForm';

const useFormData = (zone?: Zone[], valuesSet?: Function): FormItem[] => {
  const zonesCodes = zone?.map((item) => item.code);

  useEffect(() => {
    // update form values
    if (zonesCodes && valuesSet) {
      const updatedState = ['*I', '*E', '*T']
        .filter((z) => zonesCodes.includes(z))
        .map((z) => ({ code: z }));

      valuesSet(updatedState);
    }
  }, [zonesCodes?.length]);

  return [
    {
      name: 'zoneSpecial',
      label: 'Total sales in Italy',
      type: 'checkbox',
      value: '*I',
      defaultChecked: zonesCodes?.includes('*I'),
      disabled: zonesCodes?.includes('*I'),
    },
    {
      name: 'zoneSpecial',
      label: 'Total international sales',
      type: 'checkbox',
      value: '*E',
      defaultChecked: zonesCodes?.includes('*E'),
      disabled: zonesCodes?.includes('*E'),
    },
    {
      name: 'zoneSpecial',
      label: 'Global total sales',
      type: 'checkbox',
      value: '*T',
      defaultChecked: zonesCodes?.includes('*T'),
      disabled: zonesCodes?.includes('*T'),
    },
  ];
};

export { useFormData };
